// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `FriendRequestStatus`.
const FriendRequestStatus = __t.enum("FriendRequestStatus", {Pending: __t.unit(),
  Accepted: __t.unit(),
  Declined: __t.unit(),
});

export default FriendRequestStatus;


